module.exports = __webpack_public_path__ + "img/l4.751519a0.png";